import type { Dispatch, SetStateAction } from "react";
import NetworkService from "../../NetworkService";
import {
  getStoredPassengerUserId,
  setStoredPassengerUserId,
} from "./rideOrderPassengerStorage";
import { CompanyUser } from "./companyUsers";
import { OrderFormState } from "./types";

export async function hydrateStoredPassenger(
  setForm: Dispatch<SetStateAction<OrderFormState>>
): Promise<void> {
  const storedId = getStoredPassengerUserId();
  if (!storedId) return;

  try {
    const user = (await NetworkService.getUserById(storedId)) as CompanyUser;
    if (!user?.id) return;

    setForm((prev) => ({
      ...prev,
      userId: user.id,
    }));
  } catch (error: unknown) {
    const status = (error as { status?: number })?.status;
    if (status === 404) {
      setStoredPassengerUserId(null);
    }
  }
}
